import { render, staticRenderFns } from "./component.vue?vue&type=template&id=3f67315f&scoped=true&"
import script from "./component.vue?vue&type=script&lang=ts&"
export * from "./component.vue?vue&type=script&lang=ts&"
import style0 from "./component.vue?vue&type=style&index=0&id=3f67315f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67315f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f67315f')) {
      api.createRecord('3f67315f', component.options)
    } else {
      api.reload('3f67315f', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=3f67315f&scoped=true&", function () {
      api.rerender('3f67315f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TrendChart/component.vue"
export default component.exports